import { render, staticRenderFns } from "./TopKioskJobsStatistics.vue?vue&type=template&id=67c1da29"
import script from "./TopKioskJobsStatistics.vue?vue&type=script&lang=js"
export * from "./TopKioskJobsStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports